import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import callApi from '../../utils/call_apis';
import bidSchema from '../../validations/Bid'
import FormControlLabel from '@mui/material/FormControlLabel';
import Grid from '@mui/material/Grid';
import React from "react";
import Snackbar from '../generals/Snackbar';
import TextField from '@mui/material/TextField';
import { setSnackbar } from '../../stores/SnackbarSlice';
import { useFormik, Field } from "formik";
import { useDispatch } from "react-redux";
import Autocomplete from '@mui/material/Autocomplete';
import CircularProgress from '@mui/material/CircularProgress';
import { useSearchParams } from 'react-router-dom'
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import Link from '@mui/material/Link';
import { useNavigate } from "react-router-dom";
import Checkbox from '@mui/material/Checkbox';


function CreateBidForm() {

  const [searchParams, setSearchParams] = useSearchParams();
  let bid_by_emp_id = searchParams.get('bid_by_emp_id');
  // console.log('---bid_by_emp_id:', bid_by_emp_id);
  let form_action = searchParams.get('form_action');
  // console.log('---form_action:', form_action);
  const navigate = useNavigate();

  const initialValues = {
    'product_title': '',
    'product_sku': '',
    'product_title_default_value': {'product_name': '', 'product_sku': ''},
    'quantity': '',
    'max_bid_price': '',
    'price_with_gst': false,
    'price_without_gst': false,
    'discount_on_mrp': false,
    'discount_on_ptr': false,
    'bid_price_type': '1',
    // 'product_expiry': '',
    'bid_valid_till': '',
    'assign_seller_groups_arr': [],
    'assign_sellers_mob_number': '',
    'action': '',
    'product_expiry_type': '1'
  }
  const dispatch = useDispatch();

  React.useEffect(() => {
    if (form_action == 'update') {
      fetchBidDetailsBidByEmp({ id: bid_by_emp_id })
    }
    // else {
    //   addMonthsInProductExpiry()
    // }
    
  }, []);

  const [productTitleValue, setProductTitleValue] = React.useState(null);

  const [assigneeSellerGroupsIsOpen, setAssigneeSellerGroupsIsOpen] = React.useState(false);
  const [assigneeSellerGroupsOptions, setAssigneeSellerGroupsOptions] = React.useState([]);
  const assigneeSellerGroupsIsLoading = assigneeSellerGroupsIsOpen && assigneeSellerGroupsOptions.length === 0;

  const onSubmit = values => {
    // values['price_with_gst'] = reqPayload['price_with_gst'];
    // values['price_without_gst'] = reqPayload['price_without_gst'];
    // values['discount_on_mrp'] = reqPayload['discount_on_mrp'];
    // values['discount_on_ptr'] = reqPayload['discount_on_ptr'];
    // values['assign_seller_groups_arr'] = reqPayload['assign_seller_groups_arr'];
    if (form_action == 'update') {
      values['action'] = 'update';
    }
    console.log('---onSubmit--values:', values);
    submitCreateBid(values);
  }

  const formik = useFormik({
    initialValues,
    onSubmit,
    // validate,
    validationSchema: bidSchema.createBidSchema,
    validateOnChange: false
  })

  console.log('---formik--values:', formik.values);
  // console.log('---formik--errors:', formik.errors);



  const setAssigneeSellerGroupsValue = (event, name, value) => {
    console.log('---setAssigneeSellerGroupsValue---name:', event.target.name, '---value:', event.target.checked);
    // initialValues[event.target.name] = event.target.checked
    // setReqPayload({ ...reqPayload, [event.target.name]: event.target.checked })
    // console.log('---handleCheckbox--initialValues:', initialValues);
    // console.log('---handleCheckbox--reqPayload:', reqPayload);
    // console.log('---setAssigneeSellerGroupsValue---name')
    // setReqPayload({ ...reqPayload, [name]: value })
    formik.setFieldValue(name, value);
  }

  const onChangeAssigneeSellerGroupsHandle = async value => {
    // this default api does not support searching but if you use google maps or some other use the value and post to get back you reslut and then set it using setAssigneeSellerGroupsOptions 
    // console.log('---onChangeAssigneeSellerGroupsHandle---', value);
    setAssigneeSellerGroupsIsOpen(true)
    let data = { q: value }
    const response = await callApi.requestGET(`/sellers-bids/emp/bid-assignee-sellers`, data, true)
    const assigneeSellerGroups = response.data.data.dataset;
    if (assigneeSellerGroups.length == 0) {
      setAssigneeSellerGroupsIsOpen(false)
    }
    setAssigneeSellerGroupsOptions(assigneeSellerGroups);
  };

  const handleBidPriceTypeChange = (event) => {
    // setValue(event.target.value);
    formik.setFieldValue('bid_price_type', event.target.value);
  };

  const handleProductExpiryChange = (event) => {
    // setValue(event.target.value);
    // addMonthsInProductExpiry(event.target.value)
    // formik.setFieldValue('bid_price_type', event.target.value);
    formik.setFieldValue('product_expiry_type', event.target.value)
  };

  React.useEffect(() => {
    if (!assigneeSellerGroupsIsOpen) {
      setAssigneeSellerGroupsOptions([]);
    }
  }, [assigneeSellerGroupsIsOpen]);


  const successResponse = (response) => {
    // console.log('---successResponse--response:', response);
    dispatch(setSnackbar({
      status: 'success',
      message: response.data.message
    }))
  }

  const errorResponse = (error) => {
    // console.log('---errorResponse--formik--errors---222:', error.response.data.errors);
    formik.setErrors({ ...error.response.data.errors })
  }

  const fetchBidDetailsBidByEmp = async (data = {}) => {
    try {
      const response = await callApi.requestGET(`/sellers-bids/emp/bids-listing`, data, true)
      // console.log('---fetchBidDetailsBidByEmp---response:', response);
      formik.setValues(response.data.data.dataset[0])
      formik.setFieldValue('product_title_default_value', { product_name: response.data.data.dataset[0]['product_title'], sku: response.data.data.dataset[0]['product_sku']});
      // setProductTitleValue(response.data.data.dataset[0]['product_title']);
      // document.getElementById('productTitleId').value = 'asas';
      formik.setFieldValue('assign_seller_groups_arr', response.data.data.dataset[0]['assign_seller_groups_detials']);
    }
    catch (error) {
      // console.log('---fetchMetadataOfBidByEmp---error:', error);
      errorResponse(error)
    }
  }

  const submitCreateBid = async (data, query = {}) => {
    try {
      const response = await callApi.requestPOST(`/sellers-bids/emp/create-bid`, data, true)
      // console.log('---submitCreateBid---response:', response);
      successResponse(response)
      navigate('/emp/bid-listing')
    }
    catch (error) {
      // console.log('---submitCreateBid---error:', error);
      errorResponse(error)
    }
  }

  const [productSuggestionOptions, setProductSuggestionOptions] = React.useState([]);

  const onChangeProductSuggestionHandle = async value => {
    // this default api does not support searching but if you use google maps or some other use the value and post to get back you reslut and then set it using setAssigneeSellerGroupsOptions 
    // console.log('---onChangeProductSuggestionHandle---', value);
    // setAssigneeSellerGroupsIsOpen(true)
    let data = { q: value }
    const response = await callApi.requestGET(`/sellers-bids/emp/product-suggestions`, data, true)
    const assigneeSellerGroups = response.data.data.dataset;
    // if (assigneeSellerGroups.length == 0) {
      // setAssigneeSellerGroupsIsOpen(false)
    // }
    setProductSuggestionOptions(assigneeSellerGroups);
  };

  const addMonthsInProductExpiry = (addMonths=1) => {
    // console.log('---addMonthsInProductExpiry--addMonths:' + addMonths);
    // formik.setFieldValue('product_expiry', '2025-01-01' )
    // const date = new Date();
    // formik.setFieldValue('product_expiry', new Date(date.setMonth(date.getMonth() + addMonths)).toISOString().slice(0,10) )
    formik.setFieldValue('product_expiry', addMonths)
  };

  return (
    <div>
      <Grid container direction="row" alignItems="center" justifyContent="" >

        <Box component="form" className="tw-mb-20" onSubmit={formik.handleSubmit}>
          <Grid container spacing={5}>

            <Grid item xs={12} sm={12}>
              {/* <TextField id="productNameId" className="tw-w-full" label="Product Name" type="text" name="product_title" variant="outlined" onChange={formik.handleChange} value={formik.values.product_title} error={formik.errors.product_title ? true : false} helperText={formik.errors.product_title} required /> */}

              <Autocomplete
                freeSolo
                // id="productTitleIdB"
                name="product_title"
                // value={'NA'}
                // value={formik.values?.product_title || ''}
                // defaultValue={'NA'}
                // defaultValue={formik.values.product_title || null}
                // defaultValue={{
                //   product_name : 'jiiwjiws',
                //   sku : 'okodkoekdo'
                // }}
                // defaultValue={formik.values.product_title_default_value}
                value={formik.values.product_title_default_value}
                disableClearable
                // options={productSuggestionOptions.map((option) => {
                //   return option
                // })}
                options={productSuggestionOptions}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Search Product"
                    // id="productTitleId"
                    name="product_title"
                    // value={formik.values.product_title}
                    error={formik.errors.product_title ? true : false} 
                    helperText={formik.errors.product_title} 
                    // placeholder={formik.values.product_title}
                    required={formik.values.product_title == ''}
                    // onChange={formik.handleChange}
                    InputProps={{
                      ...params.InputProps,
                      type: 'search',
                    }}
                  />
                )}
                getOptionLabel={(option) => option.product_name || formik.values.product_title}
                onChange={(e, value) => {
                  formik.setFieldValue('product_title', value['product_name'])
                  formik.setFieldValue('product_sku', value['sku'])
                }}
                onInputChange={ (ev, value) => { 
                  formik.setFieldValue('product_title', value)
                  if (ev) {
                    formik.setFieldValue('product_sku', '')
                  }
                  if (ev && ev.target && (ev.target.value !== "" || ev.target.value) !== null && ev.target.value.length >= 2) {
                    onChangeProductSuggestionHandle(ev.target.value);
                  }
                }}
              />
              {/* { form_action=='update' ? <span className="tw-text-xs">Product: {formik.values.product_title} | </span> : ''}  */}
              { formik.values.product_sku ? <span className="tw-text-xs">SKU: {formik.values.product_sku}</span> : ''} 
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextField id="quantityId" className="tw-w-full" xs={12} sm={6} label="Quantity" type="number" name="quantity" variant="outlined" onChange={formik.handleChange} value={formik.values.quantity} error={formik.errors.quantity ? true : false} helperText={formik.errors.quantity} required />
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextField id="maxBidPriceId" className="tw-w-full" xs={12} sm={6} label="Base Price" type="number" name="max_bid_price" variant="outlined" onChange={formik.handleChange} value={formik.values.max_bid_price} error={formik.errors.max_bid_price ? true : false} helperText={formik.errors.max_bid_price} required />
            </Grid>
          </Grid>

          {/* <Grid container spacing={1} className="tw-my-7">
            <Grid item xs={12} sm={12}>
              <span className="tw-text-xl"><p>Price to be captured:</p></span>
            </Grid>

            <Grid item xs={12} sm={6}>
              <FormControlLabel control={<Checkbox name="price_with_gst" value={formik.values.price_with_gst} checked={formik.values.price_with_gst} onChange={handleCheckbox} />} label="Price with GST" />
            </Grid>

            <Grid item xs={12} sm={6}>
              <FormControlLabel control={<Checkbox name="price_without_gst" value={formik.values.price_without_gst} checked={formik.values.price_without_gst} onChange={handleCheckbox} />} label="Price without GST" />
            </Grid>

            <Grid item xs={12} sm={6}>
              <FormControlLabel control={<Checkbox name="discount_on_mrp" value={formik.values.discount_on_mrp} checked={formik.values.discount_on_mrp} onChange={handleCheckbox} />} label="Discount on MRP" />
            </Grid>

            <Grid item xs={12} sm={6}>
              <FormControlLabel control={<Checkbox name="discount_on_ptr" value={reqPayload.discount_on_ptr} checked={reqPayload.discount_on_ptr} onChange={handleCheckbox} />} label="Discount on PTR" />
            </Grid>
          </Grid> */}

          <Grid container spacing={1} className="tw-my-5">
            <Grid item xs={12} sm={6}>
              <FormControl>
                <FormLabel id="demo-radio-buttons-group-label">Select Bid Price Type</FormLabel>
                <RadioGroup
                  aria-labelledby="demo-radio-buttons-group-label"
                  // defaultValue="price_with_gst"
                  // defaultValue={formik.values.bid_price_type}
                  value={formik.values.bid_price_type}
                  name="radio-buttons-group"
                  // value={value}
                  onChange={handleBidPriceTypeChange}
                >
                  <FormControlLabel value="1" control={<Radio />} label="Price with GST" />
                  <FormControlLabel value="2" control={<Radio />} label="Price without GST" />
                  <FormControlLabel value="3" control={<Radio />} label="Discount on MRP" />
                  <FormControlLabel value="4" control={<Radio />} label="Discount on PTR" />
                </RadioGroup>
              </FormControl>
            </Grid>
          </Grid>

          <Grid container spacing={1} className="tw-my-5">
            <Grid item xs={12} sm={6}>
              <FormControl>
                <FormLabel id="productExpiryRadioId">Choose Product Expiry Duration:</FormLabel>
                <RadioGroup
                  aria-labelledby="productExpiryRadioId"
                  // defaultValue="price_with_gst"
                  // defaultValue={formik.values.bid_price_type}
                  value={formik.values.product_expiry_type}
                  name="productExpiryRadioBtnGrp"
                  // value={value}
                  onChange={handleProductExpiryChange}
                >
                  <FormControlLabel value="1" control={<Radio />} label="> 6 Months" />
                  <FormControlLabel value="2" control={<Radio />} label="> 1 Year" />
                  <FormControlLabel value="3" control={<Radio />} label="> 1 Year 6 Months" />
                </RadioGroup>
              </FormControl>
            </Grid>
          </Grid>

          {/* <Grid container spacing={5}>
            <Grid item xs={12} sm={12}>
              <TextField id="productExpiryId" className="tw-my-2 tw-mr-5" label="Product Expiry" type="date" name="product_expiry" onChange={formik.handleChange} value={formik.values.product_expiry} variant="outlined" InputLabelProps={{ shrink: true }} error={formik.errors.product_expiry ? true : false} helperText={formik.errors.product_expiry} required />
            </Grid>
          </Grid> */}

          <Grid container spacing={5}>
            <Grid item xs={12} sm={12}>
              <TextField id="bidValidTillId" className="tw-my-5 tw-mr-5" label="Bid Valid Till" type="date" name="bid_valid_till" onChange={formik.handleChange} value={formik.values.bid_valid_till} variant="outlined" InputLabelProps={{ shrink: true }} error={formik.errors.bid_valid_till ? true : false} helperText={formik.errors.bid_valid_till} required />
            </Grid>
          </Grid>

          <Grid container spacing={5}>
            <Grid item xs={12} sm={8}>
              <Autocomplete
                multiple
                limitTags={2}
                id="multiple-limit-tags"
                open={assigneeSellerGroupsIsOpen}
                onOpen={() => {
                  // setAssigneeSellerGroupsIsOpen(true);
                  setAssigneeSellerGroupsIsOpen(false);
                }}
                onClose={() => {
                  setAssigneeSellerGroupsIsOpen(false);
                }}
                loading={assigneeSellerGroupsIsLoading}
                options={assigneeSellerGroupsOptions}
                getOptionLabel={(option) => option.name}
                value={formik.values.assign_seller_groups_arr}
                name="assign_seller_groups_arr"
                renderInput={(params) => (
                  <TextField {...params} 
                    label="Seller Groups" 
                    name="assign_seller_groups_arr" 
                    error={formik.errors.assign_seller_groups_arr ? true : false} 
                    helperText={formik.errors.assign_seller_groups_arr} 
                    placeholder="Seller Group"
                    InputProps={{
                      // required: true,
                      ...params.InputProps,
                      endAdornment: (
                        <React.Fragment>
                          {assigneeSellerGroupsIsLoading ? (<CircularProgress color="inherit" size={20} />) : null}
                          {params.InputProps.endAdornment}
                        </React.Fragment>
                      )
                    }}
                    onChange={ev => {
                      // dont fire API if the user delete or not entered anything
                      if ((ev.target.value !== "" || ev.target.value) !== null && ev.target.value.length >= 3) {
                        onChangeAssigneeSellerGroupsHandle(ev.target.value);
                      }
                    }}
                    // required={formik.values.assign_seller_groups_arr.length === 0}
                  />
                )}
                onChange={(e, value) => { setAssigneeSellerGroupsValue(e, 'assign_seller_groups_arr', value); }}
                sx={{ width: '500px' }}
              />
            </Grid>

            <Grid item xs={12} sm={4} className="">
              <Link className='tw-float-right' component="a" href="/emp/create-sellers-group" >Create<br />Sellers Group</Link>
            </Grid>

          </Grid>

          <Grid container spacing={5}>
            <Grid item xs={12} sm={6} className="tw-mt-5">
              <TextField id="sellerMobileNumbersId" className="tw-w-full" label="Seller Mobile Numbers" type="text" name="assign_sellers_mob_number" variant="outlined" onChange={formik.handleChange} value={formik.values.assign_sellers_mob_number} error={formik.errors.assign_sellers_mob_number ? true : false} helperText={formik.errors.assign_sellers_mob_number || 'Enter value by comma seperated'} placeholder="9819550001,9819550002,9819550003" />
            </Grid>
          </Grid>

          <Grid container spacing={5}>
            <Grid item xs={12} sm={12} className="tw-mt-5">
              <Button type="submit" variant="contained">{form_action != 'update' ? 'create' : 'update'} Bid</Button>
            </Grid>
          </Grid>
        </Box>

      </Grid>

      <Snackbar />
    </div>
  );

}


export { CreateBidForm };
